"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingActionButton = exports.EditorWrapper = exports.ButtonWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ButtonWrapper = styled_components_1.default.div `
  float: right;
`;
exports.EditorWrapper = styled_components_1.default.div `
  padding: 10px;
  width: 50vw;
  height: 50vh;
  background: #cdcdcd;
`;
exports.FloatingActionButton = styled_components_1.default.button `
  position: fixed;
  bottom: 20px;
  right: 20px;
  border-radius: 50%;
  border-width: 0px;
  font-size: 2rem;
  height: 50px;
  width: 50px;
  color: white;
  background-color: #cc0000;
  box-shadow: 5px 5px 3px #aaaaaa;
  z-index: 1000;
  &:hover {
    background: #ff3333;
    cursor: pointer;
  }
`;
